document.addEventListener('DOMContentLoaded', function() {
	const meshButton = document.querySelector('.mm-internal-mesh-btn');
	const container = document.querySelector('.mm-internal-mesh-container');

	if (!meshButton || !container) {
		return;
	}

	const spanOpen = meshButton.querySelector('span.mm-btn-see-more');
	const spanClose = meshButton.querySelector('span.mm-btn-see-less');

	meshButton.addEventListener('click', function(e) {
		e.preventDefault();
		const isExpanded = container.classList.contains('mm-expanded');

		if (!isExpanded) {
			// Ouvrir: calculer la hauteur du contenu
			container.style.maxHeight = container.scrollHeight + 'px';
			container.classList.add('mm-expanded');
			spanOpen.classList.add('mm-none');
			spanClose.classList.remove('mm-none');
		} else {
			// Fermer: revenir à 200px
			container.style.maxHeight = '200px';
			container.classList.remove('mm-expanded');
			spanOpen.classList.remove('mm-none');
			spanClose.classList.add('mm-none');
		}
	});
});
